'use strict';

exports.__esModule = true;
exports['default'] = refCount;

var _actionsRegistry = require('../actions/registry');

function refCount(state, action) {
  if (state === undefined) state = 0;

  switch (action.type) {
    case _actionsRegistry.ADD_SOURCE:
    case _actionsRegistry.ADD_TARGET:
      return state + 1;
    case _actionsRegistry.REMOVE_SOURCE:
    case _actionsRegistry.REMOVE_TARGET:
      return state - 1;
    default:
      return state;
  }
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd/~/dnd-core/lib/reducers/refCount.js
 ** module id = 208
 ** module chunks = 1
 **/